export const messages = {
  editor: {
    helpText: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.help-text',
    },
    moreInformation: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.more-information',
    },
    label: {
      id: 'admin/promotions.form.regular.editor.benefit.formula.label',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.regular.view.benefit.formula.title',
    },
  },
  validation: {
    required: {
      id: 'admin/promotions.form.validation.required',
    },
  },
}
